import { apiClient } from "./client";
import type {
  AccountConfigDto,
  DomainConfigDto,
  DomainVerificationInstructionsDto,
  GlobalConfigDto,
  TestConnectionResultDto,
} from "./types";

/** §9.1 读取全局配置 */
export function getGlobalConfig() {
  return apiClient.get<GlobalConfigDto>("/config/global");
}

/** 只读当前生效收信域名(Admin/Operator 均可,建号页自动生成邮箱需要) */
export function getActiveDomain() {
  return apiClient.get<{ active_email_domain: string }>("/config/active-domain");
}

/** §9.1 保存全局配置 */
export function putGlobalConfig(cfg: GlobalConfigDto) {
  return apiClient.put<{ saved: boolean }>("/config/global", cfg);
}

/** §9.2 列出账号配置 */
export function listAccountConfigs() {
  return apiClient.get<{ accounts: AccountConfigDto[] }>("/config/accounts");
}

/** §9.2/§9.3 新增或编辑账号配置 */
export function putAccountConfig(accountId: string, cfg: Omit<AccountConfigDto, "account_id">) {
  return apiClient.put<{ account_id: string; created: boolean }>(
    `/config/accounts/${encodeURIComponent(accountId)}`,
    cfg
  );
}

/** §9.3 删除账号配置 */
export function deleteAccountConfig(accountId: string) {
  return apiClient.delete<{ account_id: string; deleted: boolean }>(
    `/config/accounts/${encodeURIComponent(accountId)}`
  );
}

/** §9.3 测试连接 */
export function testConnection(accountId: string) {
  return apiClient.post<TestConnectionResultDto>(
    `/config/accounts/${encodeURIComponent(accountId)}/test-connection`
  );
}

// ---------------- §4.1 收信域名管理 ----------------

/** 列出所有已添加的收信域名及验证状态 */
export function listDomains() {
  return apiClient.get<{ active_domain: string; domains: DomainConfigDto[] }>("/config/domains");
}

/** 新增域名,返回需要配置的 DNS 记录说明(TXT/DKIM CNAME/MX) */
export function addDomain(domain: string) {
  return apiClient.post<DomainVerificationInstructionsDto>("/config/domains", { domain });
}

/** 刷新该域名的验证状态 */
export function refreshDomain(domain: string) {
  return apiClient.post<{ domain: string; status: string; verified_at: string | null }>(
    `/config/domains/${encodeURIComponent(domain)}/refresh`
  );
}

/** 切换为当前生效收信域名(要求该域名已 VERIFIED) */
export function activateDomain(domain: string) {
  return apiClient.post<{ domain: string; active: boolean }>(
    `/config/domains/${encodeURIComponent(domain)}/activate`
  );
}

/** 删除域名跟踪记录(不能删除当前生效域名) */
export function deleteDomain(domain: string) {
  return apiClient.delete<{ domain: string; deleted: boolean }>(
    `/config/domains/${encodeURIComponent(domain)}`
  );
}
